<template>
  <LImpact>
    <template #title> Health & Medicine </template>
    <template #description>
      Quantum technologies could transform health and medicine by enabling earlier detection of diseases and improving treatment outcomes through advanced diagnostics. Precision measurements made possible by quantum sensors will lead to more accurate medical procedures and diagnostic tools. Additionally, quantum computing could accelerate drug development, facilitating the discovery of new therapies and treatments. These advancements will contribute to more personalized and efficient healthcare services, tailoring care to individual patient needs.

    </template>
    <template #image>
      <ImpactRoundedImg category-name="Health & Medicine" />
    </template>
  </LImpact>
</template>

<script setup>
import LImpact from "@/components/layout/LImpact.vue";
import ImpactRoundedImg from "@/components/impact/ImpactRoundedImg.vue";
</script>

<style scoped></style>
